import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from 'lodash';
import {api} from '../../../api'
import { Dropdown, Label } from "semantic-ui-react";

class RelationSearchMultiple extends Component {
    constructor() {
        super();
        this.state = {
            options: [
            ],
            isFetching: false,
            searchQuery: ""
        }
    }

    componentDidMount() {
        const {shouldAllowAll} = this.props;
        if (shouldAllowAll) {
            this.setState({
                options: [
                    {            
                        key: 'All',
                        text: 'All',
                        value: 'All'
                    }
                ]
            })
        }
    }

    handleSearchChange = (e, { searchQuery }) => {
        if (!searchQuery) {
            return null;
        }

        if (searchQuery.length < 3) {
            return null;
        }

        this.setState({
            isFetching: true
        })
        api.relation.selector(this.props.jwt, {
            type: this.props.relationType,
            search: searchQuery
        }, this.props.shouldAllowAll).then(options => {
            //The options returned from server may not contain currently selected values
            //In such case, we need to push these values back
            const {selectedValues} = this.props;
            const currentlySelectedOptions = [];
            _.each(selectedValues, id => {
                let optionSelected = this.state.options.filter(i => {
                    return parseInt(i.value) === parseInt(id);
                });
                if (optionSelected.length === 1) {
                    currentlySelectedOptions.push(optionSelected[0])
                }
            });
            if (this.props.shouldAllowAll) {
                options.unshift({
                    key: 'All',
                    text: 'All',
                    value: 'All'
                })
            }
            this.setState({
                isFetching: false,
                options: _.unionBy(options, currentlySelectedOptions, 'value')
            })
        }).catch(err => {
            this.setState({
                isFetching: false
            })
        })
    }

    render() {
        const {name, selectedValues, onValueChange, placeHolder} = this.props;
        const {options, isFetching} = this.state;
        return (
            <div className="row">
                <div className="col-md-2">
                    <Label as='a' color='teal' pointing='right' style={{marginTop: '5px'}}>
                        {name}
                    </Label>
                </div>
                <div className="col-md-10">
                    <Dropdown placeholder={placeHolder} 
                        value={selectedValues}
                        onChange={(e, data) => onValueChange(e, data)}
                        onSearchChange={_.debounce(this.handleSearchChange, 500, { leading: true })}
                        disabled={isFetching}
                        loading={isFetching}
                        multiple={true}
                        fluid selection options={options} search/>
                </div>
            </div>
        );
    }
}

RelationSearchMultiple.propTypes = {
    jwt: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    selectedValues: PropTypes.array.isRequired,
    placeHolder: PropTypes.string.isRequired,
    onValueChange: PropTypes.func.isRequired,
    shouldAllowAll: PropTypes.bool.isRequired,
    relationType: PropTypes.string.isRequired
};

export default RelationSearchMultiple;


// WEBPACK FOOTER //
// ./src/components/utils/searches/RelationSearchMultiple.js